//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      scrolled: false,
      scrolling: false
    }
  },
  methods: {
    handleScroll() {
      if(!this.scrolling){
        this.scrolled = window.scrollY > 600;
      }
    },
    onStart(){
      this.scrolling = true
      this.scrolled = false
    },
    onDone(){
      this.scrolling = false
    },
    onCancel(){
      this.scrolling = false
    },
  },
  beforeMount() {
    if (process.client) {
      window.addEventListener('scroll', this.handleScroll);
    }
  },
  beforeDestroy() {
    if (process.client) {
      window.removeEventListener('scroll', this.handleScroll);
    }
  }
}
